export const GNBEvent = {
  GnbClick: 'gnb_click',
  GnbMenuClick: 'gnb_menu_click',
  GnbAccountClick: 'gnb_account_click',
  GnbHomeClick: 'gnb_home_click',
  GnbLanguageClick: 'gnb_language_click',
} as const;

export interface GNBDataType {
  [GNBEvent.GnbAccountClick]: { grace_period_flag: boolean };
  [GNBEvent.GnbClick]: { name: string };
  [GNBEvent.GnbMenuClick]: { name: string; category: string };
  [GNBEvent.GnbHomeClick]: {};
  [GNBEvent.GnbLanguageClick]: {};
}
